/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";

import examesLinhaCuidadoService from "../../api/exames/examesLinhaCuidadoService";
import { periodicidadesExameLinhaCuidado } from "../../common/utils";

class ProgramaExamesLinhaCuidado extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            erro: "",
            parametrizados: [],
            showModal: false,
            formulario: this.getFormularioInicial(),
            showModalExame: false,
            formExame: { nome: "", codigo: "" },
            salvandoExame: false,
        };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.programaId !== this.props.programaId) {
            this.carregar();
        }
    }

    getFormularioInicial = () => ({
        id: null,
        exame_id: "",
        exame_label: "",
        periodicidade: "semestral",
        obrigatorio: true,
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, parametrizados: [] });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await examesLinhaCuidadoService.listarParametrizacao(programaId);
            const data = response.data || {};

            this.setState({
                loading: false,
                parametrizados: Array.isArray(data.resultados) ? data.resultados : [],
            });
        } catch (error) {
            console.error("Erro ao carregar parametrização de exames:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar a parametrização de exames."),
            });
        }
    };

    carregarExames = async (inputValue) => {
        try {
            const response = await examesLinhaCuidadoService.listarCatalogo(inputValue);
            const lista = Array.isArray(response.data) ? response.data : [];

            return lista.map((exame) => ({
                value: exame.id,
                label: exame.codigo ? `${exame.nome} (${exame.codigo})` : exame.nome,
            }));
        } catch (error) {
            console.error("Erro ao carregar catálogo de exames:", error);
            return [];
        }
    };

    abrirModalNovo = () => this.setState({ showModal: true, formulario: this.getFormularioInicial() });

    abrirModalEdicao = (registro) => {
        this.setState({
            showModal: true,
            formulario: {
                id: registro.id,
                exame_id: registro.exame_id,
                exame_label: registro.dados_exame?.nome || "",
                periodicidade: registro.periodicidade,
                obrigatorio: registro.obrigatorio,
            },
        });
    };

    fecharModal = () => this.setState({ showModal: false, formulario: this.getFormularioInicial() });

    salvar = async () => {
        const { programaId } = this.props;
        const { formulario } = this.state;

        if (!formulario.exame_id) {
            Swal.fire("Atenção", "Selecione o exame.", "warning");
            return;
        }

        this.setState({ salvando: true });

        try {
            if (formulario.id) {
                await examesLinhaCuidadoService.atualizarParametrizacao(formulario.id, {
                    periodicidade: formulario.periodicidade,
                    obrigatorio: formulario.obrigatorio,
                });
            } else {
                await examesLinhaCuidadoService.incluirParametrizacao(
                    programaId,
                    formulario.exame_id,
                    formulario.periodicidade,
                    formulario.obrigatorio
                );
            }

            this.setState({ salvando: false, showModal: false, formulario: this.getFormularioInicial() });
            await this.carregar();
            Swal.fire("Sucesso", "Parametrização salva com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao salvar parametrização de exame:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar a parametrização."), "error");
        }
    };

    remover = async (registro) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar remoção?",
            text: `Deseja remover ${registro.dados_exame?.nome || "este exame"} da parametrização desta Linha de Cuidado?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await examesLinhaCuidadoService.removerParametrizacao(registro.id);
            await this.carregar();
            Swal.fire("Sucesso", "Exame removido da parametrização.", "success");
        } catch (error) {
            console.error("Erro ao remover parametrização de exame:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível remover a parametrização."), "error");
        }
    };

    abrirModalExame = () => this.setState({ showModalExame: true, formExame: { nome: "", codigo: "" } });

    fecharModalExame = () => this.setState({ showModalExame: false });

    salvarExame = async () => {
        const { formExame } = this.state;

        if (!formExame.nome.trim()) {
            Swal.fire("Atenção", "Informe o nome do exame.", "warning");
            return;
        }

        this.setState({ salvandoExame: true });

        try {
            const resposta = await examesLinhaCuidadoService.cadastrarExame(formExame.nome.trim(), formExame.codigo.trim());
            const novo = resposta.data || {};

            this.setState((estado) => ({
                salvandoExame: false,
                showModalExame: false,
                formulario: {
                    ...estado.formulario,
                    exame_id: novo.id,
                    exame_label: novo.codigo ? `${novo.nome} (${novo.codigo})` : novo.nome,
                },
            }));

            Swal.fire("Sucesso", "Exame cadastrado e selecionado.", "success");
        } catch (error) {
            console.error("Erro ao cadastrar exame:", error);
            this.setState({ salvandoExame: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível cadastrar o exame."), "error");
        }
    };

    renderModal = () => {
        const { showModal, formulario, salvando } = this.state;

        return (
            <Modal show={showModal} onHide={this.fecharModal} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{formulario.id ? "Editar exame parametrizado" : "Incluir exame obrigatório"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Label className="mb-0">Exame *</Form.Label>
                        {!formulario.id && (
                            <Button variant="link" size="sm" onClick={this.abrirModalExame}>
                                Cadastrar novo exame
                            </Button>
                        )}
                    </div>
                    <div className="mb-3">
                        <AsyncSelect
                            cacheOptions
                            defaultOptions
                            isDisabled={Boolean(formulario.id)}
                            loadOptions={this.carregarExames}
                            value={formulario.exame_id ? { value: formulario.exame_id, label: formulario.exame_label } : null}
                            onChange={(opcao) =>
                                this.setState((estado) => ({
                                    formulario: { ...estado.formulario, exame_id: opcao?.value || "", exame_label: opcao?.label || "" },
                                }))
                            }
                            placeholder="Busque pelo nome do exame..."
                            noOptionsMessage={() => "Nenhum exame encontrado"}
                        />
                    </div>
                    <Form.Label>Periodicidade esperada *</Form.Label>
                    <Form.Select
                        className="mb-3"
                        value={formulario.periodicidade}
                        onChange={(event) =>
                            this.setState((estado) => ({ formulario: { ...estado.formulario, periodicidade: event.target.value } }))
                        }
                    >
                        {Object.entries(periodicidadesExameLinhaCuidado).map(([valor, label]) => (
                            <option key={valor} value={valor}>
                                {label}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Check
                        type="checkbox"
                        id="exame-lc-obrigatorio"
                        label="Exame obrigatório (entra no cálculo do Compliance Laboratorial)"
                        checked={formulario.obrigatorio}
                        onChange={(event) =>
                            this.setState((estado) => ({ formulario: { ...estado.formulario, obrigatorio: event.target.checked } }))
                        }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModal} disabled={salvando}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvar} disabled={salvando}>
                        {salvando ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModalExame = () => {
        const { showModalExame, formExame, salvandoExame } = this.state;

        return (
            <Modal show={showModalExame} onHide={this.fecharModalExame} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Cadastrar exame</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Nome do exame *</Form.Label>
                    <Form.Control
                        className="mb-3"
                        value={formExame.nome}
                        onChange={(event) =>
                            this.setState((estado) => ({ formExame: { ...estado.formExame, nome: event.target.value } }))
                        }
                    />
                    <Form.Label>Código (opcional)</Form.Label>
                    <Form.Control
                        value={formExame.codigo}
                        onChange={(event) =>
                            this.setState((estado) => ({ formExame: { ...estado.formExame, codigo: event.target.value } }))
                        }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModalExame} disabled={salvandoExame}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvarExame} disabled={salvandoExame}>
                        {salvandoExame ? "Salvando..." : "Cadastrar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { loading, erro, parametrizados } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <Row className="align-items-center mb-3">
                        <Col sm={8}>
                            <h5 className="mb-1">Exames da Linha de Cuidado</h5>
                            <small className="text-muted">
                                Define os exames obrigatórios e a periodicidade esperada, usados no cálculo do Compliance
                                Laboratorial.
                            </small>
                        </Col>
                        <Col sm={4} className="text-end">
                            <Button variant="outline-primary" size="sm" onClick={this.abrirModalNovo}>
                                Incluir exame
                            </Button>
                        </Col>
                    </Row>

                    {erro && <Alert variant="danger">{erro}</Alert>}

                    <Table responsive className="custom-table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Exame</th>
                                <th>Periodicidade esperada</th>
                                <th>Intervalo</th>
                                <th>Obrigatório</th>
                                <th className="text-end">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {parametrizados.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-center">
                                        Nenhum exame parametrizado para esta Linha de Cuidado.
                                    </td>
                                </tr>
                            ) : (
                                parametrizados.map((registro) => (
                                    <tr key={registro.id}>
                                        <td>{registro.dados_exame?.nome || "-"}</td>
                                        <td>{registro.periodicidade_display}</td>
                                        <td>{registro.periodicidade_dias ? `${registro.periodicidade_dias} dias` : "-"}</td>
                                        <td>
                                            <Badge bg={registro.obrigatorio ? "success" : "secondary"}>
                                                {registro.obrigatorio ? "Sim" : "Não"}
                                            </Badge>
                                        </td>
                                        <td className="text-end">
                                            <Button variant="outline-secondary" size="sm" className="me-2" onClick={() => this.abrirModalEdicao(registro)}>
                                                Editar
                                            </Button>
                                            <Button variant="outline-danger" size="sm" onClick={() => this.remover(registro)}>
                                                Remover
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>

                    {this.renderModal()}
                    {this.renderModalExame()}
                </Card.Body>
            </Card>
        );
    }
}

export default ProgramaExamesLinhaCuidado;
